import { Box } from "@chakra-ui/react";
import { PauseSvg } from "@root/assets/icons/pauseSvg";

interface PauseButtonProps {
  onClick: () => void;
  showSpinner?: boolean;
}

export const PauseButton = ({
  onClick,
  showSpinner = false,
}: PauseButtonProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      onClick={onClick}
      width="40px"
      height="40px"
      borderRadius="50%"
      bg="#005EB8"
      _hover={{
        bg: "blue.600",
      }}
      transition="all 0.2s"
    >
      <PauseSvg />
    </Box>
  );
};
